var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoReminders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a9b7504f-c146-4376-9fbd-3672bad9fcc7",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f170c06b-23cb-4447-bddf-790a1d397b91{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stop rimender ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f170c06b-23cb-4447-bddf-790a1d397b91",
    d: "M8,15.5l9.78,0-1.86-2.63L16,8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f170c06b-23cb-4447-bddf-790a1d397b91",
    d: "M14.62,16.45c0,1.74-1.71,2.7-3.81,2.7S7,18.19,7,16.45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f170c06b-23cb-4447-bddf-790a1d397b91",
    d: "M17.82,4,16.73,2.87a.23.23,0,0,0-.32,0L3.78,15a.21.21,0,0,0,0,.31l1.09,1.12a.22.22,0,0,0,.32,0L17.82,4.3A.22.22,0,0,0,17.82,4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "f170c06b-23cb-4447-bddf-790a1d397b91",
    d: "M14.62,3h0c-1.1-1.3-2.9-1.52-4.66-1.52h0A5,5,0,0,0,5.73,3.74h0A8.63,8.63,0,0,0,4.38,8.35V12.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReminders);
export default __webpack_public_path__ + "static/media/no-reminders.2dbcb71c2faa29fe1e67c41775480f41.svg";
export { ForwardRef as ReactComponent };